import { configService } from '../services/configService';

export class ApplicationIdGenerator {
  static generateId(uid, year) {
    return `${uid}-${year}`;
  }

  static parseId(applicationId) {
    const parts = applicationId.split('-');
    if (parts.length !== 2) {
      throw new Error(`Invalid application ID format: ${applicationId}`);
    }
    return {
      uid: parts[0],
      year: parseInt(parts[1])
    };
  }

  static validateId(applicationId) {
    try {
      const { uid, year } = this.parseId(applicationId);
      return uid && !isNaN(year) && year > 2000 && year < 3000;
    } catch {
      return false;
    }
  }

  static async getCurrentYearId(uid) {
    const currentYear = await configService.getCurrentActiveYear();
    return this.generateId(uid, currentYear);
  }
}

// Export convenience function for direct use
export const generateApplicationId = ApplicationIdGenerator.generateId;
